import { render, staticRenderFns } from "./SettingsOverview.vue?vue&type=template&id=0a93ce06&scoped=true"
import script from "./SettingsOverview.vue?vue&type=script&lang=js"
export * from "./SettingsOverview.vue?vue&type=script&lang=js"
import style0 from "./SettingsOverview.vue?vue&type=style&index=0&id=0a93ce06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a93ce06",
  null
  
)

export default component.exports